import React from "react";
import SmallBread from "../SmallBread";
import { PostData } from "../../api/service";
import { Button, Card, Empty, Input, Select, Spin, message } from "antd";
import {
  Grid,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from "@material-ui/core";
import { HALF_LIST, getGoodHalfName } from "../../Helper/GlobalConstants";
import ReactHTMLTableToExcel from "react-html-table-to-excel";

const { Option } = Select;

export default function ViewPayouts() {
  const [state, setState] = React.useState({
    entry_date: "",
  });

  const [error, setError] = React.useState({
    entry_date: "",
  });

  function onChange(name, value) {
    setState({
      ...state,
      [name]: value,
    });
  }

  const [data, setData] = React.useState([]);
  const [isLoaded, setIsLoaded] = React.useState(false);
  const [isSubmitting, setIsSubmitting] = React.useState(false);

  function onSubmit() {
    if (state.entry_date != "") {
      // post api
      setIsSubmitting(true);
      PostData(`/get-payout-for-a-date`, state)
        .then((resp) => {
          setData(resp);
          setIsLoaded(true);
          setIsSubmitting(false);
        })
        .catch((err) => {
          message.error(`Error in server`);
          setIsSubmitting(false);
        });
    }
  }

  return (
    <div>
      <SmallBread
        data={[
          {
            title: "Payouts",
            link: "/payouts",
          },
          {
            title: "View",
            link: "",
          },
        ]}
      />

      <br />

      <div style={{ padding: 5 }}>
        <Card>
          <Typography variant="h6" gutterBottom>
            Select the date for which you want to generate the payout
          </Typography>
          <Grid container spacing={24}>
            <Grid item xs={12} sm={12} md={3} lg={3}>
              <div style={{ fontWeight: 700 }}>
                Select Date <span style={{ color: "red" }}>*</span>
              </div>
              <Input
                type="date"
                value={state.entry_date}
                onChange={(e) => onChange("entry_date", e.target.value)}
              />
            </Grid>
            
            <Grid item xs={12} sm={12} md={3} lg={3}>
              <Button
                type="primary"
                loading={isSubmitting}
                onClick={() => onSubmit()}
                style={{ marginTop: 20 }}
              >
                Search
              </Button>
            </Grid>
          </Grid>
        </Card>
      </div>

      {/* Table to view calculation per date and half */}

      <br />

      {isSubmitting && (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            minHeight: 100,
          }}
        >
          <Spin />
        </div>
      )}

      {isLoaded && Array.isArray(data) && data.length == 0 && (
        <Card>
          <Empty description="Calculations has not been done yet" />
        </Card>
      )}

      {isLoaded && Array.isArray(data) && data.length > 0 && (
        <Card style={{ overflowX: "scroll" }}>
          <div style={{ textAlign: "center" }}>
            <ReactHTMLTableToExcel
              id="test-table-xls-button"
              className="download-table-xls-button"
              table="table-to-xls"
              filename={`Payout Report`}
              sheet="tablexls"
              buttonText="Download as XLS"
            />
          </div>
          <br />

          <table
            size="small"
            className="table table-bordered table-striped table-sm"
            id="table-to-xls"
          >
            <TableHead>
              <TableRow>
                <TableCell style={{ fontWeight: 700 }}>Sl</TableCell>
                <TableCell style={{ fontWeight: 700 }}>User ID</TableCell>
                <TableCell style={{ fontWeight: 700 }}>Name</TableCell>
                <TableCell style={{ fontWeight: 700 }}>PAN</TableCell>
                <TableCell style={{ fontWeight: 700 }}>Phone</TableCell>
                <TableCell style={{ fontWeight: 700 }}>Date</TableCell>
                <TableCell style={{ fontWeight: 700 }}>Total Payout</TableCell>
                <TableCell style={{ fontWeight: 700 }}>A/C Holder</TableCell>
                <TableCell style={{ fontWeight: 700 }}>A/C No</TableCell>
                <TableCell style={{ fontWeight: 700 }}>Bank Name</TableCell>
                <TableCell style={{ fontWeight: 700 }}>Bank Branch</TableCell>
                <TableCell style={{ fontWeight: 700 }}>Bank IFSC</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {Array.isArray(data) &&
                data.map((el, index) => (
                  <TableRow key={index}>
                    <TableCell>{index + 1}</TableCell>
                    <TableCell>{el.user_id}</TableCell>
                    <TableCell>{el.name}</TableCell>
                    <TableCell>{el.PAN}</TableCell>
                    <TableCell>{el.mno}</TableCell>
                    <TableCell>{el.entry_date}</TableCell>
                    <TableCell>{el.total_payout}</TableCell>
                    <TableCell>{el.account_holder_name}</TableCell>
                    <TableCell>{el.account_no}</TableCell>
                    <TableCell>{el.bank}</TableCell>
                    <TableCell>{el.branch}</TableCell>
                    <TableCell>{el.ifsc_code}</TableCell>
                  </TableRow>
                ))}
            </TableBody>
          </table>
          
        </Card>
      )}
    </div>
  );
}
